import OauthApplication from 'src/models/external-ticketing/OauthApplication'
import Category from 'src/models/item/Category'
import Model, { encoders, ID, JsonArray, JsonObject, MODEL_LEVEL } from 'src/models/model'
import ItemPackage from 'src/models/package/ItemPackage'
import PaymentType from 'src/models/payment/PaymentType'
import TicketType from 'src/models/showing/TicketType'
import Site from 'src/models/site/Site'

export default class ExternalTicketingClient extends Model {
  static name = 'ExternalTicketingClient'

  static versioned = true

  static level = MODEL_LEVEL.SITE

  static employeeRequiredPermissionCategories = [Model.permissionCategories.Site]

  static define () {
    this.fields = {
      id: {
        type: ID,
        required: true
      },
      oauthApplication: {
        type: OauthApplication,
        default: null,
        encode: encoders.hasOne,
        output: true
      },
      enabled: {
        type: Boolean,
        default: false
      },
      chargeBookingFee: {
        type: Boolean,
        default: false
      },
      enableDynamicTicketPricing: {
        type: Boolean,
        default: false
      },
      numberOfFutureWeeksToInclude: {
        type: Number,
        default: 24
      },
      allowMembershipOrders: {
        type: Boolean,
        default: false
      },
      allowUserManagement: {
        type: Boolean,
        default: false
      },
      giftCardRedemptionEnabled: {
        type: Boolean,
        default: false
      },
      giftCardSalesEnabled: {
        type: Boolean,
        default: false
      },
      voucherRedemptionEnabled: {
        type: Boolean,
        default: false
      },
      voucherSalesEnabled: {
        type: Boolean,
        default: false
      },
      allowedModules: {
        type: JsonArray,
        default: () => ['v1'],
        options: ['v1', 'v2']
      },
      ticketTypes: {
        type: [TicketType],
        default: () => { return [] },
        encode (data) {
          data.ticketTypeIds = _.map(this.ticketTypes.data, 'id')
        },
        reference: true
      },
      excludeTicketTypes: {
        type: Boolean,
        default: false
      },
      categories: {
        type: [Category],
        default: () => { return [] },
        encode (data) {
          data.categoryIds = _.map(this.categories.data, 'id')
        },
        reference: true
      },
      excludeCategories: {
        type: Boolean,
        default: false
      },
      itemPackages: {
        type: [ItemPackage],
        default: () => { return [] },
        encode (data) {
          data.itemPackageIds = _.map(this.itemPackages.data, 'id')
        },
        reference: true
      },
      excludeItemPackages: {
        type: Boolean,
        default: false
      },
      paymentTypes: {
        type: [PaymentType],
        default: () => { return [] },
        encode (data) {
          data.paymentTypeIds = _.map(this.paymentTypes.data, 'id')
        },
        reference: true
      },
      deliveryTypeConfiguration: {
        type: JsonObject,
        default: () => ({
          enabled_delivery_types: []
        }),
        mergeDefault: true
      },
      site: {
        type: Site,
        default: null,
        encode: encoders.hasOne
      }
    }
  }
}
